import { createSharedComposable } from '@vueuse/core';

import { useGetEntity } from '@abaninja/util-store';

import { getCustomerPortalSettings } from '../settings';

export const useCustomerPortalSettingsStore = createSharedComposable(() => useGetEntity(getCustomerPortalSettings));
